import { render, staticRenderFns } from "./Invite.vue?vue&type=template&id=f893fa68&"
import script from "./invite.js?vue&type=script&lang=js&"
export * from "./invite.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports